import { useState, useEffect } from 'react';
import { cn } from '../../utils/cn';
import { Icon } from './Icon';
import { scrollToTop } from '../../utils/scroll';

interface ScrollToTopProps {
  showAfter?: number;
  className?: string;
}

export function ScrollToTop({ showAfter = 300, className }: ScrollToTopProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setIsVisible(scrollY > showAfter);
    };

    // Check initial scroll position
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showAfter]);

  const handleClick = () => {
    scrollToTop();
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'fixed bottom-6 right-6 z-40 p-3 bg-primary-navy text-white rounded-full shadow-lg hover:bg-accent-gold hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-accent-gold focus:ring-offset-2 transition-all duration-300 transform',
        {
          'translate-y-0 opacity-100 scale-100': isVisible,
          'translate-y-16 opacity-0 scale-75 pointer-events-none': !isVisible
        },
        className
      )}
      aria-label="Scroll to top"
      title="Scroll to top"
    >
      <Icon name="chevronUp" size="md" aria-hidden={true} />
    </button>
  );
}